import React, { useState } from "react";
import { FiHeart, FiUsers } from "react-icons/fi";
import heroImg from "../assets/img/couple3.jpg";
import LoginModal from "./LoginModal";

function Hero() {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="hero-overlay">
          <div className="container hero-container">
            <div className="hero-content text-center">
              <h1 className="hero-title">
                Find Your <span>Perfect Match</span> Today
              </h1>
              <p className="hero-subtitle">
                Join thousands of happy couples who found love through our platform.
              </p>

              <div className="hero-buttons">
                <button
                  className="btn-primary"
                  onClick={() => setShowLogin(true)}
                >
                  <FiHeart className="me-2" />
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Login Modal */}
      <LoginModal
        show={showLogin}
        onClose={() => setShowLogin(false)}
        onLoginSuccess={() => {
          setShowLogin(false);
        }}
      />
    </>
  );
}

export default Hero;
